/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import parameters from '@jira/servicedesk__customer-service-forms/src/__generated__/FormsQuery$parameters.ts';
import type { FormsQuery } from '@jira/servicedesk__customer-service-forms/src/__generated__/FormsQuery.graphql.ts';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type HelpCenterSettingFormsAppEntryPointComponent = EntryPointComponent<
	{
		FormsQuery: FormsQuery;
	},
	{},
	{},
	{} | null
>;

export const helpCenterSettingFormsAppEntryPoint: EntryPoint<
	HelpCenterSettingFormsAppEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<HelpCenterSettingFormsAppEntryPointComponent>(
		/* webpackChunkName: "async-help-center-setting-forms-app" */ './HelpCenterSettingFormsApp.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: ({
		context: {
			match: {
				params: { helpCenterId },
			},
		},
		tenantContext: { cloudId, activationId },
	}: EntryPointRouteParams) => ({
		queries: {
			FormsQuery: {
				parameters,
				variables: {
					cloudId,
					helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`,
				},
				options: {
					fetchPolicy: 'store-or-network' as const,
				},
			},
		},
	}),
});
